import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Contrato } from '../modelo/contrato';
import { DebitoAutomaticoContrato, DebitoAutomaticoRequest } from '../modelo/debito-automatico-contrato';
import { DebitoAutomaticoContratoDados } from '../modelo/debito-automatico-contrato-dados';
import { DebitoAutomaticoContratoDetalhe } from '../modelo/debito-automatico-contrato-detalhe';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { SessaoService } from './sessao.service';

@Injectable()
export class DebitoAutomaticoService {

  constructor(
    private restClient: RestClientService,
    private sessaoService: SessaoService
  ) {

  }

  consultarContratoDebitoAutomatico = (contrato: Contrato): Observable<DebitoAutomaticoContratoDetalhe> => {
    let resourcePath = Config.DEBITOAUTOMATICO_PATH + "/consultarContratoDebitoAutomatico";
    resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
    resourcePath += "/nuContrato/" + contrato.nuContrato;
    return this.restClient.getResource(resourcePath).map(response => response.json());
  };

   consultarDadosContrato = (contrato: Contrato): Observable<DebitoAutomaticoContratoDados> => {
     let resourcePath = Config.DEBITOAUTOMATICO_PATH + "/consultarDadosContrato";
     resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
     resourcePath += "/nuContrato/" + contrato.nuContrato;
     const xDocumento = sessionStorage.getItem("nuDocX");
     const extraHeaders = xDocumento ? { "x-documento": xDocumento } : {};
     return this.restClient.getResource(resourcePath, extraHeaders).map(response => response.json());
   };

  efetivarAlteracaoDebitoAutomatico = (debitoAutomaticoContrato: DebitoAutomaticoContrato): Observable<DebitoAutomaticoContratoDetalhe> => {
    let resourcePath = Config.DEBITOAUTOMATICO_PATH + "/efetivarAlteracaoDebitoAutomaticoPost";
    const request: DebitoAutomaticoRequest = {
      nuCTRL: this.sessaoService.sessao.autenticado.nuCTRL,
      nuContrato: debitoAutomaticoContrato.nuContrato.toString(),
      optinLimite: debitoAutomaticoContrato.optinLimite.toString(),
      optinVencida: debitoAutomaticoContrato.optinVencida.toString(),
    };
  return this.restClient.postResource(resourcePath, request);
  };

}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/debitoautomatico.service.ts